import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker/models';
import { AddreimbursetypepopupComponent } from '../../generalpopup/addreimbursetypepopup/addreimbursetypepopup.component';
import { ApprovepopComponent } from '../../grid/approvepop/approvepop.component';
import { ComponentCanDeactivate } from '../../PendingChangesGuard ';
import { HostListener } from '@angular/core';
import { AttachmentComponent } from '../../grid/attachment/attachment.component';
import { AddrequesttypepopupComponent } from '../../generalpopup/addrequesttypepopup/addrequesttypepopup.component';
import { ActivitypopupComponent } from '../../grid/activitypopup/activitypopup.component';
@Component({
  selector: 'app-addotherrequest',
  templateUrl: './addotherrequest.component.html',
  styleUrls: ['./addotherrequest.component.css']
})
export class AddotherrequestComponent implements OnInit, ComponentCanDeactivate {
  @ViewChild('approvebar', { static: false }) approvebar;
  @ViewChild('attachmentbar', { static: false }) attachmentbar;

  formname: string = "OTHERREQUEST";
  //Display
  formmode: string = "Add";
  rtnform: string = "";

  //Mode Values
  isaddmode: boolean = false;
  iseditmode: boolean = false;
  isdeletemode: boolean = false;
  isviewmode: boolean = false;
  isapprovemode: boolean = false;
  isrejectmode: boolean = false;
  ispaymentmode: boolean = false;

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;

  isshowattachment: boolean = false;
  attachmentcount: number = 0;

  isrequesttypeaddmode: boolean = false;

  isshowapproval: boolean = false;

  isapprove: boolean = false;
  isreject: boolean = false;

  ismanualclose: boolean;

  isemploading: boolean=false;

  //Filter
  filterstatus: string = "ALL";
  filteremployeeid: any = null;
  filteremployeename: any = null;
  filterfromdate: any = null;
  filtertodate: any = null;
  filterrequesttypeid: any = null;
  filterrequesttypename: any = null;
  //Save Validation
  submitted: boolean;
  successfully: boolean;
  saveloading: boolean;
  //Edit Get Values
  otherrequestColl: any = [];
  otherrequestid: number = 0
  otherrequestBO: any = {}

  requesttypeColl: any = [];

  empColl: any = [];
  empBO: any  = {};
  otherrequestform = new FormGroup({
    otherrequestid: new FormControl(0),
    empid: new FormControl(null, Validators.required),
    requesttypeid: new FormControl(null, Validators.required),
    amount: new FormControl(null),
    transdt: new FormControl(null, Validators.required),
    descr: new FormControl(''),
    inactive: new FormControl(false),
    isaffectpayroll: new FormControl(false),
    effectivedt: new FormControl(null, Validators.required),

  });

  dateCustomClasses: DatepickerDateCustomClasses[];

  constructor(private appService: AppdataService, private loginService: LoginserviceService, private route: ActivatedRoute,
    public router: Router, private toastr: ToastrService, private productFindService: NgbModal, private datePipe: DatePipe) {
    this.route.queryParams.subscribe(params => {
      if (params.id !== undefined) {
        this.otherrequestid = params.id
      }
      if (params.rtnform !== undefined) {
        this.rtnform = params.rtnform
      }

    });
    this.fnGetParameterVariable();
    this.fnServiceChanges();

    this.dateCustomClasses = [
      { date: new Date(), classes: ['bg-warning'] },
    ];
  }

  //Get Para
  fnGetParameterVariable() {
    this.route.queryParams.subscribe(params => {
      if (params.empid !== undefined) {
        this.filteremployeeid = params.empid
      }

      if (params.empname !== undefined) {
        this.filteremployeename = params.empname
      }

      if (params.status !== undefined) {
        this.filterstatus = params.status
      }

      if (params.fromdate !== undefined) {
        this.filterfromdate = this.fnConvertDatetime(this.fnFormatDatetime(params.fromdate))
      }

      if (params.todate !== undefined) {
        this.filtertodate = this.fnConvertDatetime(this.fnFormatDatetime(params.todate))
      }
      if (params.requesttypeid !== undefined) {
        this.filterrequesttypeid = params.requesttypeid
      }

      if (params.requesttypename !== undefined) {
        this.filterrequesttypename = params.requesttypename
      }

    })
  }

  fnServiceChanges() {
    this.loginService.serviceAuthChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.fnUserFailedForm();
      }

    });
  }



  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnGetUserRoleList();
      }

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    try {
      this.isaddmode = true;
      this.otherrequestform.reset();
      this.fnInitializeFormGroup();

      if (this.otherrequestid > 0) {
        this.fngetOtherRequest();
      }
      this.fngetRequestType();
      this.fngetEmployee();

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }
  fnCheckUserPririvilage() {
    var _check: boolean = false;
    if (this.otherrequestid > 0) {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
    } else {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
    }

    this.isapprovemode = this.loginService.fnCheckUserRoleAction(this.formname, 'APPROVE')
    this.isrejectmode = this.loginService.fnCheckUserRoleAction(this.formname, 'REJECT')
    this.ispaymentmode = this.loginService.fnCheckUserRoleAction(this.formname, 'PAYMENT')
    this.isrequesttypeaddmode = this.loginService.fnCheckUserRoleAction('RequestType', 'CREATE')


    return _check;
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }
  fnInitializeFormGroup() {
    this.otherrequestform.setValue({
      otherrequestid: 0,
      empid: null,
      requesttypeid: null,
      amount: null,
      transdt: new Date(),
      descr: '',
      inactive: false,
      isaffectpayroll: false,
      effectivedt: new Date(),

    })
  }
  fngetRequestType() {
    var data = {
      'requesttypeid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getRequestType(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.requesttypeColl = res.json().result;
            console.log(this.requesttypeColl)
          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }



  fngetEmployee() {
    this.isemploading = true;
    var data = {
      'empid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getEmpListView(data)
      .subscribe(
        (res) => {
          this.isemploading = false;
          if (res.json().status === 200) {
            this.empColl = res.json().result;
            this.fnChangeEmpLookup();
          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.isemploading = false;
          this.toastr.error('Error', err);
        })
  }


  //Get 
  fngetOtherRequest() {
    if (this.showProgress) {
      return;
    }
    var data = {
      'otherrequestid': this.otherrequestid,
      'companyid': this.loginService.fnGetCompanyId()
    }
    this.appService.fngetOtherRequest(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.fnHideProgress();

            this.otherrequestColl = res.json().result;
            var editdata = this.otherrequestColl[0];
            this.otherrequestBO = editdata;
            this.fnEditMode(editdata);
          }
          else {
            this.fnHideProgress();

            this.loginService.fnAPIError(res.json())
          }

        },
        (err) => {
          this.fnHideProgress();

          this.toastr.error('Error', err);
        })
  }

  fnChangeEmpLookup() {
    var empid = 0;

    empid = this.otherrequestform.get("empid").value;

    if (empid > 0) {
      for (let abo of this.empColl) {
        if (abo.empid === empid) {
          this.empBO = abo;
        }
      }

    }
    else {
      this.empBO = {};
    }


  }


  //Save Btn Click
  fnSaveBtnClick() {
    try {
      if (this.saveloading) {
        return;
      }

      this.submitted = true;
      this.successfully = false;
      if (this.loginService.fnCheckFornControlNotfound(this.otherrequestform.get('effectivedt'))) {
        this.otherrequestform.controls['effectivedt'].setErrors(null);
      }


      //Validate
      if (this.otherrequestform.valid) {

        if (this.loginService.fnCompareDateValidation(this.otherrequestform.get('effectivedt').value, this.otherrequestform.get('transdt').value)) {
          this.otherrequestform.controls['effectivedt'].setErrors({ 'notfound': true });
          return
        }


        this.saveloading = true;

        //Check
        var data = {
          'otherrequestid': this.otherrequestid,
          'transdt': this.fnFormatDatetime(this.otherrequestform.get('transdt').value),
          'empid': this.otherrequestform.get('empid').value,
          'requesttypeid': this.otherrequestform.get('requesttypeid').value,
          'amount': this.otherrequestform.get('amount').value,
          'descr': this.otherrequestform.get('descr').value,
          'effectivedt': this.fnFormatDatetime(this.otherrequestform.get('effectivedt').value),
          'inactive': this.otherrequestform.get('inactive').value,
          'isaffectpayroll': this.otherrequestform.get('isaffectpayroll').value,
          'companyid': this.loginService.fnGetCompanyId(),
          'createdby': this.loginService.fnGetModUserId(),
          'modifiedby': this.loginService.fnGetModUserId(),
        }



        if (this.otherrequestform.get('otherrequestid').value > 0) {
          //Update 
          this.fnSetOtherRequest(data);
        }
        else {
          //Insert 
          this.fnInsertOtherRequest(data);
        }


      }
    } catch (ex) {
      this.saveloading = false;

      this.fnShowErrorMsg(ex);
    }
  }


  //Insert
  fnInsertOtherRequest(data) {

    this.appService.fnInsertOtherRequest(data).subscribe(
      (res) => {
        this.saveloading = false;

        if (res.json().status === 200) {
          if (res.json().result != "") {
            this.fnResetSaveFlag();
            this.toastr.success('', "The new OtherRequest has been added successfully.Insert Successfully");
            this.fnInsertActivityLog('INSERT', 0, this.fngetDescriptionRefno(data));

            var _result = res.json().result;
            if (_result.length > 0) {
              this.fnEditFormEdit(_result[0].otherrequestid);
            }
          
          }
        }
        else {
          this.loginService.fnAPIError(res.json())
        }
      },
      (err) => {
        this.saveloading = false;

        this.toastr.error('Error', err);
      });

  }

  //Set
  fnSetOtherRequest(data) {

    this.appService.fnSetOtherRequest(data).subscribe(
      (res) => {
        this.saveloading = false;

        if (res.json().status === 200) {
          if (res.json().result != "") {
            this.fnResetSaveFlag();
            this.toastr.success('', "The OtherRequest has been updated successfully.");
            this.fnInsertActivityLog('EDIT', this.otherrequestid, this.fngetDescriptionRefno(data));
            this.fnEditFormEdit(this.otherrequestid);
              
          }
        }
        else {
          this.loginService.fnAPIError(res.json())
        }
      },
      (err) => {
        this.saveloading = false;

        this.toastr.error('Error', err);
      });

  }

  fnEmployeeSearchFn(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return item.empname.toLocaleLowerCase().indexOf(term) > -1 ||
      item.staffcode.toLocaleLowerCase().indexOf(term) > -1;
  }


  //AddRequestType
  private fnAddRequestType() {

    const modalRef = this.productFindService.open(AddrequesttypepopupComponent, { size: <any>'l' });

    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

      this.fngetRequestType();

      if (receivedEntry > 0) {
        this.otherrequestform.patchValue({ requesttypeid: receivedEntry })
      }
    });

  }
 
  fnEditFormEdit(id) {

    this.otherrequestid = id;
    this.isaddmode = false;
    this.iseditmode = false;
    this.isdeletemode = false;
    this.isviewmode = true;


    let queryParams = {
      'id': id,
      'status': this.filterstatus,
      'empid': this.filteremployeeid,
      'empname': this.filteremployeename,
      'fromdate': this.fnFormatDatetime(this.filterfromdate),
      'todate': this.fnFormatDatetime(this.filtertodate),
      'requesttypeid': this.filterrequesttypeid,
      'requesttypename': this.filterrequesttypename,
    }


    this.router.navigate([], { relativeTo: this.route, queryParams: queryParams }).then(() => {
      this.ngOnInit();
    });


  }


  //Close
  async fnCloseForm() {
    try {
      if ((this.isaddmode || this.iseditmode) && !this.ismanualclose) {
        var a = await this.loginService.fnConfirmFormLeave();
        if (a === false) {
          return false;
        }
      }

      this.ismanualclose = true;

      if (this.rtnform !== '') {
        this.router.navigate(['/' + this.rtnform]);
      }
      else {
        let navigationExtras: NavigationExtras = {
          queryParams: {
            'status': this.filterstatus,
            'empid': this.filteremployeeid,
            'empname': this.filteremployeename,
            'fromdate': this.fnFormatDatetime(this.filterfromdate),
            'todate': this.fnFormatDatetime(this.filtertodate),
            'requesttypeid': this.filterrequesttypeid,
            'requesttypename': this.filterrequesttypename,
          }
        }

        this.router.navigate(['/OtherRequest'], navigationExtras);
      }
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  private fnEditMode(deptBO) {
    deptBO.transdt = this.fnConvertDatetime(this.fnFormatDatetime(deptBO.transdt));
    deptBO.effectivedt = this.fnConvertDatetime(this.fnFormatDatetime(deptBO.effectivedt));

    this.otherrequestform.setValue({
      otherrequestid: deptBO.otherrequestid,
      empid: deptBO.empid,
      requesttypeid: deptBO.requesttypeid,
      amount: deptBO.amount,
      transdt: deptBO.transdt,
      descr: deptBO.descr,
      effectivedt: deptBO.effectivedt,
      inactive: deptBO.inactive,
      isaffectpayroll: deptBO.isaffectpayroll,
   
    });

    this.formmode = "Edit";

    this.isaddmode = false;
    this.iseditmode = false;
    this.isdeletemode = false;
    this.isviewmode = true;

    this.fnChangeEmpLookup();
    this.fnVisibilityApproveStatus();
    this.fnGetAttachmentCount();
  }


  //Approvals
  fnApproveBtnClick(type) {


    this.approvebar.formtype = type;
    this.approvebar.fnInitializeFormGroup();
    this.approvebar.fnGetApproveForms();

    this.isshowapproval = !this.isshowapproval

  }

  fnCloseApproveBtnClick(data) {
    this.isshowapproval = !this.isshowapproval

    if (data === 'DONE') {
      this.fngetOtherRequest();
    }

  }

  fnVisibilityApproveStatus() {

    this.isapprove = false;
    this.isreject = false;

    if (this.otherrequestBO.approvedstatus !== '') {
      if (this.otherrequestBO.approvedstatus === 'Approve') {
        this.isreject = true;
      }
      else if (this.otherrequestBO.approvedstatus === 'Reject') {
        this.isapprove = true;
      }
    }
    else {
      this.isapprove = true;
      this.isreject = true;
    }

  }

  fnEditBtnClick() {
    this.iseditmode = true;

    this.isviewmode = false;
  }
  //#Attachment
  fnAttachmentBtnClick() {

    const modalRef = this.productFindService.open(AttachmentComponent, { size: <any>'xxl' });
    modalRef.componentInstance.formname = this.formname;
    modalRef.componentInstance.trxid = this.otherrequestid;
    modalRef.componentInstance.formmode = "EDIT";
    modalRef.componentInstance.fnGetAttachment();

    

    modalRef.result.then(() => {
      this.fnGetAttachmentCount()
    }, () => {
      this.fnGetAttachmentCount()
    })


    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {
      if (receivedEntry === 'DONE') {
        this.fngetOtherRequest();
      }
    });

  
  }


  fnAttachmentSave(tid) {

  

  }

  fnSetAttachmentCount(data) {

    this.attachmentcount = data;
  }





  //Approvals POP
  fnShowApprovalPop(stauts) {

    const modalRef = this.productFindService.open(ApprovepopComponent, { size: <any>'l' });
    modalRef.componentInstance.formmode = stauts;
    modalRef.componentInstance.formname = this.formname;
    modalRef.componentInstance.formid = this.otherrequestid;

    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

      if (receivedEntry === 'DONE') {
        this.fngetOtherRequest();
      }


    });
  }

  
  //Attachment
  fnGetAttachmentCount() {
    if (this.otherrequestid > 0) {
      var data = {
        'trxid': this.otherrequestid,
        'trxtype': this.formname,
      }


      this.appService.fngetAttachmentCountDetails(data).subscribe(
        (res) => {
          if (res.json().status === 200) {
            var result = res.json().result;
            if (result.length > 0) {
              this.attachmentcount = result[0].attachmentcount
            }
          }
          else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        });
    }

  }

  fnAddActivity(){

    const modalRef = this.productFindService.open(ActivitypopupComponent, { size: <any>'l' });
    modalRef.componentInstance.formname = this.formname;
    modalRef.componentInstance.trxid = this.otherrequestid;

    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {      

     
    });

  }

  fnFormatDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        return this.datePipe.transform(dt, "yyyy-MM-dd")
      }

    } else {
      return null
    }

  }

  fnConvertDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        var dateParts = dt.split("-");
        var sdate = new Date(+dateParts[0], dateParts[1] - 1, +dateParts[2] + 1);
        sdate.setMinutes(sdate.getMinutes() + sdate.getTimezoneOffset());
        return sdate;
      }

    } else {
      return null
    }

  }
  fngetDescriptionRefno(data) {
    var rtnstr = "";
    try {
      if (data.transdt) {
        rtnstr = rtnstr + data.transdt;
      }

      if (data.empid) {
        rtnstr = rtnstr + " - " + data.empid;
      }

      if (data.empname) {
        rtnstr = rtnstr + " - " + data.empname;
      }
    } catch {

    }
    return rtnstr;
  }
  @HostListener('window:beforeunload')
  canDeactivate(): any {
    if (this.isaddmode || this.iseditmode) {
      return false;
    }
    else {
      return true;
    }
  }

  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc, companyid: this.loginService.fnGetCompanyId(),
        logby: this.loginService.fnGetModUserId(),
      }


      this.appService.fnInsertActivity(data).subscribe(
        (res) => {
        },
        (err) => {

        });

    } catch {

    }
  }
  fnResetSaveFlag(){
    this.submitted=false;
    this.successfully=false;
}
  private fnShowProgress() {
    this.showProgress = true;
  }
  private fnHideProgress() {
    this.showProgress = false;
  }
  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }






}
